import { Button, TextLink } from '@vds/buttons';
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { Body } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useLazyGetCancelPendingOrderByNameQuery } from '../../features/devicesAndPlans/cancelPendingOrderFetch';
import { isDesktop, isTab } from '../utils/globalConfig';
import { setModelTagging } from '../utils/tagging';
import ComponentLoader from './ComponentLoader';
import { useDispatch } from 'react-redux';
import { savePersistantDestinations,savePersistantDates } from '../../features/selectedData/persistantDataReducer';
import { setRetainDatesAndDestinations,saveSelectedDestinations,updateSelectedPlanData, saveSelectedDeviceDetails } from '../../features/selectedData/selectedDataReducer';



const StyledSpace = styled.div`
margin-left:${isDesktop || isTab ? '20px' : ''};
margin-bottom:${isDesktop || isTab ? '' : '20px'};
`

const StyledButtonDiv = styled.div`
display:${isDesktop || isTab ? 'flex' : ''};
`

const Space = styled.div`
padding-top: 24px;


`
const CancelPendingOrderModal = ({ setCancelPendingOrderModal, cancelPendingOrderObj, showErrorModal,showSuccessModal,pendingOrderDeviceInfo }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(true);
    const [cancelPendingOrderResponseData, setCancelPendingOrderResponseData] = useState();

    const onOpenedChange = value => {
        setModelTagging('cancelPendingOrderModal', 'cancelPendingOrderModal', value);
        if (!value) {
            navigate(-1, { replace: true })
            setCancelPendingOrderModal(false)
        }
    };

    const getPendingOrderPayLoad = () => {
        let payload = {
            "orderNumber": pendingOrderDeviceInfo?.pendingOrderNumber,
            "dateSubmitted": pendingOrderDeviceInfo?.effectiveDate,
            "description": pendingOrderDeviceInfo?.spoDescription,
            "accNumber": pendingOrderDeviceInfo?.accNumber
        }
        return payload;
    }


    const [triggerSubmitPendingOrder, { data, error, isLoading, isSuccess }] = useLazyGetCancelPendingOrderByNameQuery(getPendingOrderPayLoad());


    useEffect(() => {
        setCancelPendingOrderResponseData(data?.body?.data?.cancelOrder);
    }, [data])

    const onModalClose = () => {
        setShowModal(false);
    }

    const submitPendingOrder = () => {
        triggerSubmitPendingOrder(getPendingOrderPayLoad());
    }


    useEffect(() => {
        if (isSuccess) {
            setShowModal(false);
            dispatch(saveSelectedDestinations([]));
            dispatch(savePersistantDestinations([]));
            dispatch(savePersistantDates({}));
            dispatch(updateSelectedPlanData({}));
            dispatch(saveSelectedDeviceDetails({}));
            dispatch(setRetainDatesAndDestinations(false));
            window.location.href = '/digital/nsa/secure/ui/intl/trip'
        }
    }, [cancelPendingOrderResponseData])

    useEffect(() => {
        if (error) {
            setCancelPendingOrderModal(false);
            showErrorModal(error)
        }
    }, [error])



    return (
        <>
            <Modal
                opened={showModal}
                onOpenedChange={onOpenedChange}
                ariaLabel="cancelPendingOrderModal"
                id = "cancelPendingOrderModal"

            >
                {isLoading &&
                    <ComponentLoader></ComponentLoader>
                }
                {error ?
                    <></>
                    :
                    <>
                        <ModalBody>
                            <ModalTitle bold size="large">{cancelPendingOrderObj?.title}</ModalTitle>
                            <Space />
                            <Body size="large" >{cancelPendingOrderObj?.message}</Body>
                            <Space />
                        </ModalBody>
                        <ModalFooter>
                            <StyledButtonDiv>
                                <Button onClick={() => submitPendingOrder()} use="secondary" size="small">{cancelPendingOrderObj?.ctaList[1]?.ctaLabel}</Button>
                                <StyledSpace></StyledSpace>
                                <Button onClick={() => onModalClose()} size="small">{cancelPendingOrderObj?.ctaList[0]?.ctaLabel}</Button>
                            </StyledButtonDiv>
                        </ModalFooter>
                    </>}
            </Modal>

        </>

    );
}

export default CancelPendingOrderModal;